/* eslint-disable */
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import DistrictList from "./DistrictList";
import masterLabels from "../labels/master_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
  addDistrictData,
  getDistrictData,
  editDistrict,
  resetDistrict,
  resetDistrictList,
} from "../actions/masterManagementAction";
import { SET_ALL_DISTRICT } from "../../../common/constants/ActionTypes";
import Select from "react-select";

const DistrictForm = ({
  addDistrict,
  setAddDistrict,
  setDistrictState,
  flgDomicile,
  districtCode,
  districtName,
  districtState,
  divisionId,
  setDistrictCode,
  setDistrictName,
  setDivisionId,
}) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  let [divisionList, setDivisionList] = useState([""]);

  const onSubmit = (data, addDistrict, setAddDistrict) => {
    let requestBody = {
      district: {
        name: data.districtName,
        statecode: districtState,
        divisionid: data.divisionId ? data.divisionId : null,
        flgDomicile: data.isDomicile ? data.isDomicile : false,
        isActive: data.isActive,
        isDeleted: false,
      },
    };
    dispatch(resetDistrictList());
    if (addDistrict.Mode == "Add") {
      dispatch(
        addDistrictData(
          requestBody,
          setAddDistrict,
          setDistrictState,
          setDistrictName,
          setDistrictCode,
          setDivisionId
        )
      );
    } else if (addDistrict.Mode == "Edit") {
      requestBody.district.code = addDistrict.code;
      requestBody.district.statecode = addDistrict.districtState;
      requestBody.district.divisionid = addDistrict.divisionid;
      requestBody.district.flgDomicile = addDistrict.flgDomicile;
      dispatch(
        editDistrict(
          requestBody,
          setAddDistrict,
          setDistrictState,
          setDistrictName,
          setDistrictCode,
          setDivisionId
        )
      );
    }
  };

  useEffect(() => {
    if (addDistrict && addDistrict.Mode == "Add") {
      dispatch(resetDistrictList());
      setDistrictState(false);
      setDistrictName("");
      setDivisionId(false);
    }
    setDivisionList([
      { DivisionId: 1, DivisionName: "Nashik" },
      { DivisionId: 2, DivisionName: "Amaravati" },
      { DivisionId: 3, DivisionName: "Aurangabad" },
      { DivisionId: 4, DivisionName: "Nagpur" },
      { DivisionId: 5, DivisionName: "Pune" },
      { DivisionId: 6, DivisionName: "Kokan" },
    ]);
    addDistrict.Mode == "Edit" &&
      addDistrict.districtcode > 0 &&
      dispatch(getDistrictData(addDistrict.districtcode));
    addDistrict.Mode == "Edit" &&
      addDistrict.districtcode > 0 &&
      setDivisionId(addDistrict.divisionid);
    dispatch({
      type: SET_ALL_DISTRICT,
      payload: {},
    });
    // eslint-disable-next-line
  }, []);

  const onDistrictStateChange = (e) => {
    dispatch(resetDistrict());
    dispatch(resetDistrictList());
    let districtSelectedState = e.target.value;
    setDistrictState(districtSelectedState);
  };
  const onDivisionChange = (e) => {
    dispatch(resetDistrictList());
    let districtSelectedDivision = e.target.value;
    setDivisionId(districtSelectedDivision);
  };

  const { districtStatesList, districtDetails } = useSelector(
    (state) => state.masterManagementReducer,
    shallowEqual
  );

  const onCancelButton = () => {
    setAddDistrict({ Mode: false });
    setDistrictState(false);
    setDistrictName("");
    setDistrictCode("");
    setDivisionId(false);
    dispatch(resetDistrict());
    dispatch(resetDistrictList());
  };

  // Prepare options
  const districtStateOptions =
    districtStatesList?.stateDtoList?.map((el) => ({
      value: el.code,
      label: el.name,
    })) || [];

  // Find the selected value for edit mode or existing value
  const selectedDistrictState =
    districtStateOptions.find(
      (option) =>
        option.value ===
        (districtState ||
          (addDistrict?.Mode === "Edit" && addDistrict.districtstate))
    ) || null;

  return addDistrict.Mode == false ? (
    <div>
      <DistrictList setAddDistrict={setAddDistrict} />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5">
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
                <h4>
                  <p className="float-left">
                    {addDistrict.Mode == "Add"
                      ? masterLabels.districtForm.Add_District
                      : masterLabels.districtForm.Update_District}
                  </p>
                </h4>
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <div className="row">
              <div className="col-md-2">
                <label className="float-left font-weight-bold">
                  {masterLabels.districtForm.States}
                  <span className="redColor">*</span>
                </label>
                {/* <select
                  className='form-control mt-1'
                  name="districtState"
                  value={districtState}
                  onInput={onDistrictStateChange}
                  ref={register({ required: true })}
                  defaultValue={addDistrict && addDistrict.Mode == 'Edit' && addDistrict.districtstate}
                  disabled={addDistrict && addDistrict.Mode == 'Edit' && true}
                >

                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {districtStatesList && districtStatesList.stateDtoList && districtStatesList.stateDtoList.length > 0 && districtStatesList.stateDtoList.map((element, index) =>
                    <option key={index} value={element.code}>{element.name}</option>
                  )}
                </select> */}
                <br />
                <Select
                  name="districtState"
                  options={districtStateOptions}
                  onChange={(selectedOption) => {
                    const value = selectedOption?.value || "";
                    onDistrictStateChange({
                      target: {
                        name: "districtState",
                        value,
                      },
                    });
                  }}
                  value={selectedDistrictState}
                  placeholder={commonLabels.COMBO_SELECT}
                  isClearable
                  isDisabled={addDistrict?.Mode === "Edit"}
                  inputRef={register({ required: true })}
                />

                {_.get("districtState.type", errors) === "required" && (
                  <p className="errorText float-left">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
              </div>

              {districtState && districtState == 27 ? (
                <div className="col-md-2">
                  <label className="float-left font-weight-bold">
                    {masterLabels.districtForm.Divisions}
                    <span className="redColor">*</span>
                  </label>
                  <select
                    className="form-control mt-1"
                    name="divisionId"
                    value={divisionId}
                    onInput={onDivisionChange}
                    ref={register({ required: true })}
                    defaultValue={
                      addDistrict &&
                      addDistrict.Mode == "Edit" &&
                      addDistrict.divisionid
                    }
                    disabled={addDistrict && addDistrict.Mode == "Edit" && true}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {divisionList &&
                      divisionList.length > 0 &&
                      divisionList.map((element, index) => (
                        <option key={index} value={element.DivisionId}>
                          {element.DivisionName}
                        </option>
                      ))}
                  </select>

                  {_.get("divisionId.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              ) : (
                ""
              )}
              <div className="col-md-3">
                <label className="font-weight-bold float-left">
                  {masterLabels.districtForm.District_Name}
                  <span className="redColor">*</span>
                </label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="districtName"
                  placeholder={masterLabels.districtForm.District_Name}
                  ref={register({ required: true, maxLength: 300 })}
                  defaultValue={
                    addDistrict &&
                    addDistrict.Mode == "Edit" &&
                    addDistrict.districtName
                      ? addDistrict.districtName
                      : ""
                  }
                  onChange={(event) => setDistrictName(event.target.value)}
                />
                {_.get("districtName.type", errors) === "required" && (
                  <p className="errorText float-left">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
                {_.get("districtName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">
                    {commonLabels.MAX_CHAR_VALUE_300}
                  </p>
                )}
              </div>
              {districtState && districtState == 27 ? (
                <div className="col-md-2">
                  <label className="float-left font-weight-bold  text-left w-100">
                    {masterLabels.districtForm.isDomicile}?&nbsp;&nbsp;
                  </label>
                  <input
                    className="float-left text-left"
                    type="checkbox"
                    name="isDomicile"
                    value={true}
                    defaultChecked={
                      districtDetails &&
                      districtDetails.district &&
                      districtDetails.district.flg_domicile
                    }
                    disabled={addDistrict && addDistrict.Mode == "Edit" && true}
                    ref={register({})}
                  />
                </div>
              ) : (
                ""
              )}
              <div className="col-md-1">
                <label className="float-left font-weight-bold text-left w-100">
                  {masterLabels.districtForm.District_Status}?&nbsp;&nbsp;
                </label>
                <input
                  className="float-left text-left"
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={
                    districtDetails &&
                    districtDetails.district &&
                    districtDetails.district.isActive
                  }
                  ref={register({})}
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-10"></div>
              <div className="col-md-2 text-right mr-10">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => onCancelButton()}
                >
                  {commonLabels.BUTTON_CANCEL}
                </button>
                <button
                  type="submit"
                  className=" btn btn-primary custom_button   "
                  onClick={handleSubmit((e) => {
                    onSubmit(e, addDistrict, setAddDistrict);
                  })}
                >
                  {commonLabels.BUTTON_SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DistrictForm;
